(function($){
    $(document).on('click','.layout-5-accordion-title',function(){

        $(this).toggleClass("active").next().slideToggle();

        $(".layout-5-accordion-text").not($(this).next()).slideUp(300);

        $(this).siblings().removeClass("active");

    });
})(jQuery);
